import React from 'react';
export function CrossCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.082 4.94A9.931 9.931 0 0012.016 2H12a10 10 0 00-.016 20H12a10 10 0 007.082-17.06zm-4.256 8.478a.999.999 0 11-1.416 1.412L12 13.414l-1.416 1.412A1 1 0 119.17 13.41L10.586 12l-1.412-1.419a1 1 0 111.416-1.412L12 10.586l1.416-1.412a1 1 0 011.414 1.416L13.414 12l1.412 1.418z"
  }));
}